module.exports = __webpack_public_path__ + "static/carousel-04@2x-4f3cd7e251ecdec7f20fdf749c51058f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/carousel-04@2x.jpg
// module id = 2521
// module chunks = 168707334958949